import { render, staticRenderFns } from "./DarkTheme.vue?vue&type=template&id=82ccdfd0&"
import script from "./DarkTheme.vue?vue&type=script&lang=js&"
export * from "./DarkTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports